import "/__w/1/s/BotFramework-WebChat/packages/component/src/Middleware/ActivityGrouping/ui/PartGrouping/CollapsibleGrouping.module_built.css";
const classes = {"collapsible-grouping__content--open":"wDvoJHW_collapsible-grouping__content--open","collapsible-grouping__header":"wDvoJHW_collapsible-grouping__header","collapsible-grouping__toggle":"wDvoJHW_collapsible-grouping__toggle","collapsible-grouping__list":"wDvoJHW_collapsible-grouping__list","collapsible-grouping__chevron":"wDvoJHW_collapsible-grouping__chevron","collapsible-grouping__content":"wDvoJHW_collapsible-grouping__content","collapsible-grouping__title":"wDvoJHW_collapsible-grouping__title","collapsible-grouping":"wDvoJHW_collapsible-grouping","collapsible-grouping--open":"wDvoJHW_collapsible-grouping--open"}
export default classes

const _collapsible_grouping__content__open0 = classes["collapsible-grouping__content--open"]
export { _collapsible_grouping__content__open0 as "collapsible-grouping__content--open" }

const _collapsible_grouping__header0 = classes["collapsible-grouping__header"]
export { _collapsible_grouping__header0 as "collapsible-grouping__header" }

const _collapsible_grouping__toggle0 = classes["collapsible-grouping__toggle"]
export { _collapsible_grouping__toggle0 as "collapsible-grouping__toggle" }

const _collapsible_grouping__list0 = classes["collapsible-grouping__list"]
export { _collapsible_grouping__list0 as "collapsible-grouping__list" }

const _collapsible_grouping__chevron0 = classes["collapsible-grouping__chevron"]
export { _collapsible_grouping__chevron0 as "collapsible-grouping__chevron" }

const _collapsible_grouping__content0 = classes["collapsible-grouping__content"]
export { _collapsible_grouping__content0 as "collapsible-grouping__content" }

const _collapsible_grouping__title0 = classes["collapsible-grouping__title"]
export { _collapsible_grouping__title0 as "collapsible-grouping__title" }

const _collapsible_grouping0 = classes["collapsible-grouping"]
export { _collapsible_grouping0 as "collapsible-grouping" }

const _collapsible_grouping__open0 = classes["collapsible-grouping--open"]
export { _collapsible_grouping__open0 as "collapsible-grouping--open" }
